import { createBrowserRouter, Navigate } from "react-router";
import { setUnauthenticatedHandler } from "./api/fetcher";
import { RequireAuth } from "./components/RequireAuth";
import { BookIndex } from "./screens/book/BookIndex";
import { BookLayout } from "./screens/book/BookLayout";
import { Overview } from "./screens/book/overview/Overview";
import {
  AudiobookScreen,
  CastingScreen,
  ChaptersScreen,
  RenderProgressScreen,
  RenderScreen,
  ReviewScreen,
  StyleSheetScreen,
} from "./screens/book/screens";
import { Dashboard } from "./screens/Dashboard";
import { SignIn } from "./screens/SignIn";

/** Every route of the SPA. Screen packages swap placeholder components; the paths stay. */
export const router = createBrowserRouter([
  { path: "/signin", element: <SignIn /> },
  {
    element: <RequireAuth />,
    children: [
      { path: "/", element: <Dashboard /> },
      {
        path: "/books/:id",
        element: <BookLayout />,
        children: [
          { index: true, element: <BookIndex /> },
          { path: "overview", element: <Overview /> },
          { path: "chapters", element: <ChaptersScreen /> },
          { path: "style-sheet", element: <StyleSheetScreen /> },
          { path: "review/:chapterId", element: <ReviewScreen /> },
          { path: "review", element: <ReviewScreen /> },
          { path: "casting", element: <CastingScreen /> },
          { path: "render", element: <RenderScreen /> },
          { path: "render/progress", element: <RenderProgressScreen /> },
          { path: "audiobook", element: <AudiobookScreen /> },
        ],
      },
      { path: "*", element: <Navigate to="/" replace /> },
    ],
  },
]);

/**
 * A 401 on any call sends the Author to the gate through the router, not
 * through window.location: a full page load would throw away the query cache
 * and the language the switcher just set. The path they were on travels in
 * the router state, so sign-in lands them back where they were.
 */
setUnauthenticatedHandler(() => {
  const { pathname, search } = router.state.location;
  if (pathname === "/signin") return;
  void router.navigate("/signin", { replace: true, state: { from: `${pathname}${search}` } });
});
